/** 异常调用查询 */
import React from 'react';
import {message, Table} from 'antd';
import api from "../../../lib/api";

class ComTable extends React.Component{
  isPageSizeChange = false;
  state = {
    scrollY: 560,
    page: 1,
    pageSize: 30,
    tbData: [],
    orders: {},
    loading: false,
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  columns = [
    {
      title: '调用页面',
      dataIndex: 'path',
      render: (val, row, index) => (
        <span className="c-primary cursor" onClick={() => this.toPage(row.path)}>{row.path}</span>
      ),
    }, {
      title: '调用时间',
      width: 140,
      dataIndex: 'createTime',
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '响应时间',
      width: 90,
      dataIndex: 'requestTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.requestTime} ms</span>
      )
    }, {
      title: '请求方式',
      width: 90,
      dataIndex: 'methodType',
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '状态码',
      width: 80,
      dataIndex: 'httpCode',
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '是否缓慢',
      width: 90,
      dataIndex: 'slowlyFlag',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.slowlyFlag === true ? '是' : row.slowlyFlag === false ? '否' : '-'}</span>
      )
    }, {
      title: '数据量',
      width: 80,
      dataIndex: 'decodedBodySize',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{(+row.decodedBodySize / 1024).toFixed(3)} kb</span>
      )
    }, {
      title: '浏览器版本',
      width: 150,
      dataIndex: 'browserType',
      render: (val, row) => (
        <span>{row.browserType}{row.browserVersion}</span>
      )
    }, {
      title: '系统',
      width: 80,
      dataIndex: 'systemType'
    }, {
      title: 'IP',
      width: 120,
      dataIndex: 'ip'
    },
  ];
  UNSAFE_componentWillMount() {
    this.ajaxErrorData();
    this.setState({
      scrollY: document.documentElement.clientHeight - 360
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 360
      })
    }
  };
  // 跳转页面
  toPage(path) {
    const {dateTimeVal, startTime, endTime} = this.props.filterData;
    const params = {
      url: path,
      statisticsType: '',
      dateTimeVal,
      startDate: startTime,
      endDate: endTime
    };
    sessionStorage.setItem('filterData', JSON.stringify(params));
    this.props.history.push(`/apm/home/interfaceDetails?url=${path}`);
  };
  // 表格数据
  ajaxErrorData() {
    this.setState({loading: true});
    const {page, pageSize, orders} = this.state;
    const {startTime, endTime, resourcePath, methodType} = this.props.filterData;
    const params = {
      startTime,
      endTime,
      resourcePath,
      methodType,
      page,
      pageSize,
      sortFile: orders.field || null,
      orderBy: orders.direct || null
    };
    api.ajaxErrorData(params).then(res => {
      this.setState({loading: false});
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // pageSize 改变
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      page: 1,
      pageSize: size
    }, () => {
      this.ajaxErrorData();
    });
  };
  // 页数 排序 改变
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    let page = extra.action === 'sort' ? 1 : pagination.current;
    let orders = {};
    if (sorter.order) {
      orders = {
        field: sorter.field,
        direct: sorter.order === "ascend" ? "asc" : "desc"
      }
    }
    this.setState({
      orders,
      page,
      pagination: Object.assign(this.state.pagination, {current: page, pageSize: pagination.pageSize}),
      pageSize: pagination.pageSize
    }, () => {
      this.ajaxErrorData();
    });
  };
  render() {
    const { tbData, pagination, loading, scrollY } = this.state;
    return (
      <div className='card'>
        <Table scroll={{x: 1000, y: scrollY}} bordered loading={loading} pagination={pagination} rowKey={(record, index) => index}
               columns={this.columns} dataSource={tbData} onChange={this.pageChange} />
      </div>
    );
  }
};
export default ComTable;
